import request, { METHODS } from "src/utils/api-base";

type TenantReportParams = {
  days?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  categoryId?: string;
  productId?: string;
  userId?: string;
};

const buildParams = (params: TenantReportParams) => {
  const { ...query } = params;
  const cleaned = Object.fromEntries(
    Object.entries(query).filter(
      ([, value]) => value !== undefined && value !== ""
    )
  );
  return cleaned;
};

const dashboardApis = {
  /** ---------------- TENANT DASHBOARD ---------------- **/
  getTenantDashboardSummary: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/summary",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantStockMovement: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/stock-movement",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantSalesOverview: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/sales-overview",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantPurchaseOverview: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/purchase-overview",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantLowStockAlerts: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/low-stock",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantCategorySales: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/category-sales",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantTopProducts: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/top-products",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantRecentSales: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/recent-sales",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },
  getTenantRecentPurchases: (params: TenantReportParams) => {
    const query = buildParams(params);
    return request({
      route: "/app/dashboard/recent-purchases",
      method: METHODS.GET,
      params: query,
      auth: true,
    });
  },

  getMetrics: (params: any) =>
    request({
      route: "/admin/metrics",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    }),

  /** 🔹 Super Admin Metrics */
  getSuperAdminMetric: () =>
    request({
      route: "/admin/metrics/super-admin",
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),

  /** 🔹 Super Admin Plan Usage */
  getSuperAdminPlanUsage: (params?: { months?: number }) =>
    request({
      route: "/admin/metrics/plan-usage",
      method: METHODS.GET,
      params,
      auth: true,
      isAdminAuth: true,
    }),

  /** 🔹 Tenant Admin Metrics */
  getTenantAdminMetric: (tenantId: string) =>
    request({
      route: `/admin/metrics/tenant-admin/${tenantId}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),

  /** 🔹 Tenant Manager Metrics */
  getTenantManagerMetric: (tenantId: string) =>
    request({
      route: `/admin/metrics/tenant-manager/${tenantId}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),

  /** 🔹 Tenant Staff Metrics */
  getTenantStaffMetric: (tenantId: string, userId: string) =>
    request({
      route: `/admin/metrics/tenant-staff/${tenantId}?userId=${userId}`,
      method: METHODS.GET,
      auth: true,
      isAdminAuth: true,
    }),
};

export default dashboardApis;
